import React from 'react'

interface UnsavedChangesModalProps {
    isOpen: boolean
    saving: boolean
    onSaveAndContinue: () => void
    onDiscardAndContinue: () => void
    onCancel: () => void
}

export default function UnsavedChangesModal({ isOpen, saving, onSaveAndContinue, onDiscardAndContinue, onCancel }: UnsavedChangesModalProps) {
    if (!isOpen) return null

    return (
        <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Modifications non enregistrées</h5>
                        <button type="button" className="close" onClick={onCancel}>
                            <span>&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <p className="mb-0">Vous avez des modifications non enregistrées sur cet onglet. Voulez-vous les enregistrer avant de changer d'onglet ?</p>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={saving}>
                            Rester sur cet onglet
                        </button>
                        <button type="button" className="btn btn-danger" onClick={onDiscardAndContinue} disabled={saving}>
                            Changer sans enregistrer
                        </button>
                        <button type="button" className="btn btn-eseller-color" onClick={onSaveAndContinue} disabled={saving}>
                            {saving ? 'Enregistrement...' : 'Enregistrer et changer'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
